import { useExchangeInfoStore } from "src/store";
import CSelect from "../CSelect";
import styles from "./ExchangeSelect.module.scss";
import { TradeType } from "src/api/types";

type Props = {
  tradeType: TradeType;
};

export default function ExchangeSelect(props: Props) {
  const { tradeType } = props;
  const store = useExchangeInfoStore();
  const {
    exchanges,
    selectedSpotPair,
    selectedUbPerpPair,
    selectedCbPerpPair,
    selectedExchangeKey,
    setSelectedExchangeKey,
    setSelectedExchangeAccountId, // 更新 account
  } = store;

  let options = exchanges.map((exchange) => {
    return {
      value: exchange.id,
      label: exchange.name,
    };
  });

  switch (tradeType) {
    case TradeType.SPOT:
      if (!!selectedSpotPair && !!selectedSpotPair.exchanges) {
        options = options.filter((option) => {
          return selectedSpotPair.exchanges.includes(option.label);
        });
      }
      break;
    case TradeType.UB_PERP:
      if (!!selectedUbPerpPair && !!selectedUbPerpPair.exchanges) {
        options = options.filter((option) => {
          return selectedUbPerpPair.exchanges.includes(option.label);
        });
      }
      break;
    case TradeType.CB_PERP:
      if (!!selectedCbPerpPair && !!selectedCbPerpPair.exchanges) {
        options = options.filter((option) => {
          return selectedCbPerpPair.exchanges.includes(option.label);
        });
      }
      break;
  }

  const selectedOption = options.find((option) => option.label === selectedExchangeKey);
  const handleChange = (option) => {
    const value = option.label;
    const selectedExchange = exchanges.find((item) => item.name === value);
    if (!selectedExchange) {
      throw new Error(`Exchange name not found: ${value}`);
    }
    setSelectedExchangeKey(selectedExchange.key);

    // 自动更新 Account
    setSelectedExchangeAccountId(-1); // 重置 Account
  };

  return (
    <CSelect
      classname={styles.container}
      label={"交易所"}
      placeholder="选择交易所"
      options={options}
      onChange={handleChange}
      value={selectedOption}
    />
  );
}
